import { QueryOptions, useUserOrKioskQuery } from "../common/lib/fetch";
import { Result } from "../common/Result";
import { Order, PurchaseOrder, LoadoutGroup } from "../UserFlow";

export interface Loadout {
  loadoutGroup?: LoadoutGroup;
  order?: Order;
}

export interface VerifyOrderNumberResponse {
  loadout: Result<Loadout>;
  purchaseOrder: Result<PurchaseOrder | null>;
}

const useVerifyOrderNumber = (
  siteId: string,
  orderNumber: string,
  options: QueryOptions<VerifyOrderNumberResponse>,
  kioskId?: string) => {

  const baseUrl = `/api/sites/${siteId}/getOrderByNumber`;
  const urlParams = new URLSearchParams();

  urlParams.append('number', orderNumber);
  if (kioskId) urlParams.append('kioskId', kioskId);

  return useUserOrKioskQuery<VerifyOrderNumberResponse>({
    path: `${baseUrl}?${urlParams.toString()}`
  }, options);
}

export default useVerifyOrderNumber;
